import gql from "graphql-tag";

export const SEND_ADD_CONTACT_CARD_SMS = gql`
  mutation sendAddContactCardSms($contactId: ID!, $market: String) {
    sendAddContactCardSms(contactId: $contactId, market: $market)
  }
`;
